
export function enhanceTopicsWithFeedData(topics, rssFeed) {
  return topics.map(topic => Object.assign(topic, rssFeed.find(e => e.title.indexOf(`#${topic.episode_nr} `) > -1)));
}



// WEBPACK FOOTER //
// ./src/utils.js